module.exports = __webpack_public_path__ + "element-icons.woff?535877f50039c0cb49a6196a5b7517cd";


//////////////////
// WEBPACK FOOTER
// ./node_modules/element-ui/lib/theme-chalk/fonts/element-icons.woff
// module id = 257
// module chunks = 0